<template>
  <div class="pa-4">
    <div v-if="loading" class="text-center">
      <v-skeleton-loader
        type="list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line, list-item-avatar-two-line">
      </v-skeleton-loader>
    </div>
    <v-card elevation="0" v-if="!loading">
      <v-card-text class="text-center text-h6" v-if="total == 0">
        {{ $t("message.no_notifications") }}
      </v-card-text>
      <div class="pa-2" v-if="notifications.length > 0" v-allowed="'view_payment_alerts'">
        <v-subheader>
          <v-icon color="primary">mdi-bell-outline</v-icon>
          {{ $t("message.notifications") }}
        </v-subheader>
        <template v-for="(n, index) in notifications">
          <v-list-item three-line :key="index + '_' + n.transactionId + index" @click="viewDetails(n)">
            <v-list-item-content>
              <v-list-item-title v-text="n.title">
              </v-list-item-title>
              <v-list-item-subtitle class="error--text font-weight-bold">
                {{ $t("message." + n.status) }}
              </v-list-item-subtitle>
              <v-list-item-subtitle v-text="n.user">
              </v-list-item-subtitle>
              <div v-if="n.paymentIntent" class="mt-2">
                <v-btn x-small color="error" outlined
                  :loading="retryingPaymentId === n.transactionId"
                  :disabled="retryingPaymentId === n.transactionId"
                  @click.stop="retryPayment(n)">
                  <v-icon x-small class="mr-1">mdi-credit-card-refresh-outline</v-icon>
                  {{ $t("message.retry_failed_payment_now") }}
                </v-btn>
              </div>
            </v-list-item-content>
            <v-list-item-action>
              {{ currency }}{{ n.amount }}
            </v-list-item-action>
          </v-list-item>
          <v-divider v-if="index + 1 < notifications.length" :key="index"></v-divider>
        </template>
      </div>
    </v-card>
  </div>
</template>
<script>
import Api from "@/services/Api";

export default {
  components: {
  },
  data() {
    return {
      loading: true,
      total: 0,
      /** @type {any[]} */
      notifications: [],
      currency: '$',
      retryingPaymentId: /** @type {any} */ (null),
    };
  },
  created() {
    if (this.$store.state.managedAcademy) {
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/notifications")
        .then((response) => {
          response = response.data;
          if (response) {
            this.loading = false;
            this.$store.dispatch("setNotificationsCount", response.totalCount);
            this.total = response.totalCount;
            this.currency = response.currency;
            if (response.totalCount > 0) {
              this.notifications = response.alerts;
            }
          }
        })
        .catch(() => {
          this.loading = false;
          this.showAlert(
            "error",
            this.$t("message.error_generic")
          );
        })
    }
  },
  methods: {
    viewDetails(n) {
      if (n.transactionId)
        this.navigateTo({ name: 'viewtransaction', params: { sessionId: n.transactionId } })
      else if (n.userId)
        this.navigateTo({ name: "viewmember", params: { memberid: n.userId } });
    },
    retryPayment(n) {
      this.retryingPaymentId = n.transactionId;
      Api()
        .post(
          "payments/academy/" + this.$store.state.managedAcademy +
          "/subscription/" + n.transactionId + "/retry/payment",
          { paymentIntent: n.paymentIntent, invoice: n.invoiceId, index: 1 }
        )
        .then((response) => {
          this.retryingPaymentId = null;
          if (response.data) {
            const idx = this.notifications.findIndex((x) => x.transactionId === n.transactionId);
            if (idx > -1) this.notifications.splice(idx, 1);
            this.total = this.notifications.length;
            this.$store.dispatch("setNotificationsCount", this.total);
            this.showAlert("success", this.$t("message.success"));
          }
        })
        .catch(() => {
          this.retryingPaymentId = null;
          this.showAlert("error", "Declined");
        });
    },
  }
}
</script>

<style scoped></style>
